export default __webpack_public_path__ + "static/media/car.d6a88bb4.png";